// LivestreamPinnedMessages.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Marquee from '../component/Marquee.jsx';

import LinkSubstring from '../container/LinkSubstring.js';

import PinBlueIconSource from '../../img/ic_pin_livechat.svg';
import CloseIconSource from '../../img/ic_topbar_close.svg';
import defaults from '../resource/defaults.js';

const DEFAULT_DURATION_SECONDS = 12;
const HALF_WIDTH_CHAR_DURATION = 0.1;
const FULL_WIDTH_CHAR_DURATION = 0.2;

export const calculateMarqueeDuration = text => {
  // Match English letters, numbers, and half-width symbols (including spaces and punctuation)
  const halfWidthRegex = /[\u0020-\u007E]/g;
  const halfWidthMatches = text.match(halfWidthRegex);
  const halfWidthCount = halfWidthMatches ? halfWidthMatches.length : 0;

  // Full-width/Chinese character count = total length - half-width character count
  const fullWidthCount = text.length - halfWidthCount;

  // Calculate duration proportionally: half-width 0.1s/char, full-width 0.2s/char
  const duration =
    halfWidthCount * HALF_WIDTH_CHAR_DURATION +
    fullWidthCount * FULL_WIDTH_CHAR_DURATION;

  return Math.max(DEFAULT_DURATION_SECONDS, duration);
};

export const LivestreamPinnedMessages = ({
  streamId = '',
  pinnedMessages = defaults.EMPTY_ARRAY,
  isStreamer = false,
  removePinnedMessage = defaults.NULL_FUNCTION,
}) => {
  if (!pinnedMessages || !pinnedMessages.length) return null;
  return (
    <StyledLivestreamPinnedMessages>
      {pinnedMessages.map(
        message =>
          message && (
            <PinnedMessageWrapper key={message.id}>
              <PinnedIcon>
                <img src={PinBlueIconSource} alt="pinned" />
              </PinnedIcon>
              <TextWrapper>
                <PinnedMessage>
                  <Marquee
                    duration={calculateMarqueeDuration(message.text)}
                    justify={'center'}
                  >
                    <LinkSubstring>{message.text}</LinkSubstring>
                  </Marquee>
                </PinnedMessage>
              </TextWrapper>
              {isStreamer && (
                <RemoveIcon
                  onClick={() => {
                    removePinnedMessage({ streamId });
                  }}
                >
                  <img src={CloseIconSource} alt="remove" />
                </RemoveIcon>
              )}
            </PinnedMessageWrapper>
          )
      )}
    </StyledLivestreamPinnedMessages>
  );
};

LivestreamPinnedMessages.propTypes = {
  streamId: PropTypes.string,
  pinnedMessages: PropTypes.array,
  isStreamer: PropTypes.bool,
  removePinnedMessage: PropTypes.func,
};

const StyledLivestreamPinnedMessages = styled.div`
  position: relative;
`;

const PinnedMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  height: 36px;
  width: 100%;
  border-radius: 4px;
  background-color: rgba(74, 144, 226, 0.6);
`;

const PinnedIcon = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: 8px;
  > img {
    width: 24px;
    height: 100%;
    border-radius: 50%;
    background-color: #ffffff;
  }
`;

const RemoveIcon = styled.div`
  position: relative;
  width: 16px;
  height: 16px;
  margin-left: 8px;
  cursor: pointer;
  > img {
    width: 16px;
    height: 100%;
  }
`;

const TextWrapper = styled.div`
  display: inline-flex;
  min-width: 0;
  flex: 1;
`;

const PinnedMessage = styled.div`
  font-size: 12px;
  font-weight: normal;
  line-height: 14px;
  color: #ffffff;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default LivestreamPinnedMessages;
